import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import debounce from 'lodash/debounce';
import flowRight from 'lodash/flowRight';

import MainSearchField from './MainSearchField';
import ProjectResult from '../projectArchive/ProjectResult';
import { getProjectListBySearchTerm, getProjectListByLastUpdate } from '../candidateArchive/api/candidateArchiveAPI';
import ConfirmationModal from './ConfirmationModal';

import * as UTILS from '../utils/utilFunctions';
import * as CONSTANTS from '../constants';

// import TEXT from '../candidateArchive/staticContent/text';
import TEXT_GENERAL from '../text';

class ProjectFinder extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      projectList: [],
      searchFieldValidationError: false,
      showConfirmationModal: false
    };
    this.mainSearchFieldChange = flowRight(
      debounce(this.mainSearchFieldChange, 200),
      e => e.persist() || e
    );
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  componentDidMount() {
    this.getProjectListByLastUpdateAPICall();
  }

  getProjectListByLastUpdateAPICall() {
    getProjectListByLastUpdate()
      .then(responseBody => {
        let projectList = responseBody;
        if (CONSTANTS.isLienert) projectList = projectList.filter(project => project.status === 'In Bearbeitung');
        this.setState({ projectList });
      })
      .catch(err => {
        this.errorHandling(err);
      });
  }

  isValidateSearchTerm(searchTerm) {
    if (!UTILS.isSearchtermValid(searchTerm)) {
      this.setState({ searchFieldValidationError: true });
      return false;
    }
    if (this.state.searchFieldValidationError) this.setState({ searchFieldValidationError: false });
    return true;
  }

  getProjectListBySearchTermAPICall(searchTerm) {
    if (!this.isValidateSearchTerm(searchTerm) || !searchTerm) return;
    getProjectListBySearchTerm(searchTerm)
      .then(responseBody => {
        let projectList = responseBody;
        if (CONSTANTS.isLienert) projectList = projectList.filter(project => project.status === 'In Bearbeitung');
        this.setState({ projectList });
      })
      .catch(err => {
        this.errorHandling(err);
      });
  }

  mainSearchFieldChange = e => {
    if (e.target.value !== '') this.getProjectListBySearchTermAPICall(e.target.value);
  };

  onProjectClick = row => {
    console.log(row);
    this.setState({ showConfirmationModal: true, selectedProject: row });
  };

  renderDescriptionText() {
    return (
      <div className="userResetConfirmation-descriptionText">
        <p>{this.props.confirmationDescription}</p>
      </div>
    );
  }

  renderContentText() {
    const projectInfos = this.state.selectedProject.slice();
    projectInfos.shift();
    return (
      <div className="userDeleteConfirmation-contentText">
        {projectInfos.map(field => (
          <p key={field}>{field}</p>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className="container">
        <MainSearchField
          placeholder={this.props.placeholder}
          onChange={this.mainSearchFieldChange}
          error={this.state.searchFieldValidationError}
          helperText={this.state.searchFieldValidationError && this.props.helperText}
          onExtendedSearchClick={() => console.log('extendedSearchClicked')}
        />
        <ProjectResult handleProjectSelected={this.onProjectClick} projectList={this.state.projectList} />
        {this.state.showConfirmationModal && (
          <ConfirmationModal
            key="confirmation-addCandidateTo-Project"
            handleClose={() => this.setState({ showConfirmationModal: false })}
            open={this.state.showConfirmationModal}
            buttonPrimaryAction={() => {
              this.setState({ showConfirmationModal: false });
              this.props.handleProjectSelected(this.state.selectedProject);
            }}
            headlineText={TEXT_GENERAL.ConfirmationModal.headlineText}
            descriptionText={this.renderDescriptionText()}
            contentText={this.renderContentText()}
            buttonPrimaryText={TEXT_GENERAL.ConfirmationModal.buttonPrimaryText}
          />
        )}
      </div>
    );
  }
}

ProjectFinder.defaultProps = {
  placeholder: 'Bitte suchen Sie nach einem Auftrag'
};

ProjectFinder.propTypes = {
  placeholder: PropTypes.string,
  handleProjectSelected: PropTypes.func.isRequired,
  helperText: PropTypes.string.isRequired,
  confirmationDescription: PropTypes.string.isRequired
};

export default ProjectFinder;
